import { createSelector } from "reselect";
import { LensTypeVariantStepContainer } from "../../../../../../../../steps/LensTypeVariantStep/steps/LensTypeVariantStep/LensTypeVariantStepContainer.js";
import "../../../../../../../add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../bundles/state/bundles/selectors.js";
import "../../../../../../../bundles/state/bundles/reducer.js";
import { getSelectedLensType } from "../../../../../../state/configurator/selectors.js";
import "../../../../../../state/configurator/reducer.js";
import "../../../../../../../products/state/products/selectors.js";
import "../../../../../../../products/state/products/reducer.js";
const lensTypeVariantStep = {
  stepStatus: createSelector(
    getSelectedLensType,
    (selectedLensType) => Number(selectedLensType?.variants?.length) > 1 ? "sub-step" : "hidden"
  ),
  view: LensTypeVariantStepContainer
};
export {
  lensTypeVariantStep
};
//# sourceMappingURL=lens-type-variant.js.map
